module.exports = __webpack_public_path__ + "static/img/demo_site.974906f5.svg";